import React, { useMemo } from 'react';

import { Select } from '@infoods/lifebase-ui';
import { observer } from 'mobx-react';
import { DateRangeFilterTabs } from '../../../../shared/components/tabs';

import classes from './DashboardFilter.module.scss';
import { entityDashboardFilterStore } from '../../../stores/entityDashboardFilterStore';
import { solutionsStore } from '../../../../shared/stores/solutionsStore';
import { getFilterOptions } from './utils/getFilterOptions';

const DashboardFilter = observer(() => {
  const {
    solutionTypeFilter,
    dateRangePreset,
    setSolutionTypeFilter,
    setDateRangePreset,
  } = entityDashboardFilterStore;

  const { availableSolutions } = solutionsStore;

  const solutionTypeOptions = useMemo(
    () => getFilterOptions(availableSolutions),
    [availableSolutions],
  );

  return (
    <div className={classes.container}>
      {solutionTypeOptions && (
        <div className={classes.solutionBlock}>
          <p>Solution:</p>
          <Select
            value={solutionTypeFilter}
            className={classes.solutionSelect}
            options={solutionTypeOptions}
            onChange={setSolutionTypeFilter}
            variant="outlined"
            size="small"
          />
        </div>
      )}
      <DateRangeFilterTabs value={dateRangePreset} onValueChange={setDateRangePreset} />
    </div>
  );
});

export { DashboardFilter };
